import React from 'react';
import { FrontPage } from 'dea-core';
import menuLogo from '../../assets/images/logo-opp.png';
import foregroundImg from '../../assets/images/U1-T1-00A.png';
import backgroundImg from '../../assets/images/U1-T1-00B-01.png';

const data = {
  title: 'The Opioid Epidemic',
  subTitle: 'Module 1 of 4',
  intro: (
    <p>
      In this module, you will learn about what opioids are, and how the
      epidemic evolved with opioid prescription misuse, heroin use, and illicit
      fentanyl use. You will learn from two individuals who have personal
      experience with the opioid epidemic.
    </p>
  ),
  logo: menuLogo,
  foregroundImg,
  backgroundImg
};

export default {
  title: 'Welcome',
  path: '/',
  content: <FrontPage data={data} />
};



// WEBPACK FOOTER //
// ./src/data/home/index.js